import type { Obra } from './modelo.js';

/**
 * El catalogo de zonas de Mallorca donde el equipo trabaja.
 *
 * Son coordenadas REALES, y son lo unico que este fichero guarda: aqui ya no
 * hay obras. Las veinte de demostracion vivieron aqui mientras se decidia si el
 * modulo merecia la pena; ahora que se cargan obras de verdad, arrancar con
 * ellas dentro solo servia para mezclar lo inventado con lo que no lo es. Se
 * conservan en `datos-de-prueba.ts`, que solo leen las pruebas.
 *
 * Las zonas SI se quedan: son el catalogo del que elige el formulario y lo que
 * el mapa delimita y rotula. Sin ellas no se puede dar de alta nada.
 */

/*
  ESTE CATALOGO YA NO ES LA LISTA CERRADA DE DONDE ELEGIR.

  Lo era, y se quedaba corto en cuanto alguien traia una obra de un sitio que no
  estuviera en el —«Costa d'en Blanes» no existia—. Ahora la zona se escribe, el
  catalogo solo SUGIERE, y el punto del mapa sale de localizar la direccion.
  Estas coordenadas se siguen usando como respaldo cuando no se ha localizado
  nada: mejor el centro del barrio que el mar.
*/
/** Coordenadas reales de cada zona, y el municipio al que pertenece. */
export const ZONAS: Record<string, { lat: number; lon: number; municipio: string }> = {
  'Santa Ponsa': { lat: 39.5185, lon: 2.4782, municipio: 'Calvià' },
  "Port d'Andratx": { lat: 39.5452, lon: 2.3881, municipio: 'Andratx' },
  'Camp de Mar': { lat: 39.5392, lon: 2.4244, municipio: 'Andratx' },
  'Costa de la Calma': { lat: 39.5101, lon: 2.4623, municipio: 'Calvià' },
  'El Toro': { lat: 39.4941, lon: 2.4853, municipio: 'Calvià' },
  'Portals Nous': { lat: 39.5322, lon: 2.5671, municipio: 'Calvià' },
  Bendinat: { lat: 39.5351, lon: 2.5884, municipio: 'Calvià' },
  Palma: { lat: 39.5712, lon: 2.6501, municipio: 'Palma' },
  Sóller: { lat: 39.7662, lon: 2.7152, municipio: 'Sóller' },
  'Cala Vinyes': { lat: 39.5084, lon: 2.5321, municipio: 'Calvià' },

  // Calvià, el resto de la costa: donde esta casi toda la cartera.
  "Costa d'en Blanes": { lat: 39.5361, lon: 2.5768, municipio: 'Calvià' },
  Palmanova: { lat: 39.5227, lon: 2.5352, municipio: 'Calvià' },
  Magaluf: { lat: 39.5105, lon: 2.5327, municipio: 'Calvià' },
  'Son Caliu': { lat: 39.5274, lon: 2.5505, municipio: 'Calvià' },
  'Sol de Mallorca': { lat: 39.5044, lon: 2.5220, municipio: 'Calvià' },
  Illetes: { lat: 39.5390, lon: 2.6010, municipio: 'Calvià' },
  'Cas Català': { lat: 39.5390, lon: 2.6080, municipio: 'Calvià' },
  Peguera: { lat: 39.5366, lon: 2.4470, municipio: 'Calvià' },
  'Cala Fornells': { lat: 39.5310, lon: 2.4430, municipio: 'Calvià' },
  'Calvià vila': { lat: 39.5658, lon: 2.5064, municipio: 'Calvià' },
  'Son Ferrer': { lat: 39.5010, lon: 2.5090, municipio: 'Calvià' },
  'Es Capdellà': { lat: 39.5760, lon: 2.4650, municipio: 'Calvià' },

  // Andratx.
  Andratx: { lat: 39.5758, lon: 2.4200, municipio: 'Andratx' },
  "S'Arracó": { lat: 39.5610, lon: 2.3830, municipio: 'Andratx' },
  'Sant Elm': { lat: 39.5820, lon: 2.3520, municipio: 'Andratx' },
  'Cala Llamp': { lat: 39.5390, lon: 2.3760, municipio: 'Andratx' },
  'Mont-Port': { lat: 39.5430, lon: 2.3820, municipio: 'Andratx' },

  // Palma: los barrios donde se mueve la cartera.
  'Son Vida': { lat: 39.5880, lon: 2.6120, municipio: 'Palma' },
  'La Bonanova': { lat: 39.5560, lon: 2.6220, municipio: 'Palma' },
  Gènova: { lat: 39.5530, lon: 2.6060, municipio: 'Palma' },
  'Cala Major': { lat: 39.5510, lon: 2.6090, municipio: 'Palma' },
  "Sant Agustí": { lat: 39.5450, lon: 2.6000, municipio: 'Palma' },
  'Santa Catalina': { lat: 39.5730, lon: 2.6390, municipio: 'Palma' },
  'El Terreno': { lat: 39.5640, lon: 2.6280, municipio: 'Palma' },
  'Son Armadams': { lat: 39.5680, lon: 2.6330, municipio: 'Palma' },
  'El Molinar': { lat: 39.5590, lon: 2.6800, municipio: 'Palma' },
  Portixol: { lat: 39.5610, lon: 2.6690, municipio: 'Palma' },
  'Ciutat Jardí': { lat: 39.5460, lon: 2.7080, municipio: 'Palma' },
  'Can Pastilla': { lat: 39.5340, lon: 2.7200, municipio: 'Palma' },
  'Son Rapinya': { lat: 39.5840, lon: 2.6200, municipio: 'Palma' },
  'Casco antiguo · Palma': { lat: 39.5700, lon: 2.6500, municipio: 'Palma' },
};

/**
 * Quien puede figurar como responsable.
 *
 * NO ES UNA LISTA ESCRITA A MANO. Antes lo era —dos comerciales inventados—, y
 * al empezar a cargar obras reales la unica opcion posible era asignarselas a
 * alguien que no existe. Ahora sale de quien esta usando la aplicacion mas
 * quien ya figura en alguna obra, que es lo unico que el modulo sabe de verdad
 * sin preguntarle a la API.
 */
export function responsables(obras: Obra[], quien: string): string[] {
  const nombres = new Set<string>();
  if (quien.trim() !== '') nombres.add(quien);
  for (const o of obras) if (o.responsable) nombres.add(o.responsable);
  return [...nombres].sort((a, b) => a.localeCompare(b));
}
